export default "__VITE_ASSET__2a36556c__"